import React from 'react';
import { MapContainer, TileLayer, CircleMarker, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { ViolationTypeBadge } from './StatusBadge';

const STATUS_COLOR = {
    pending: '#F59E0B',
    approved: '#22C55E',
    rejected: '#EF4444',
    appealed: '#2563EB',
};

/**
 * Geographic view of violations. Plots each report with GPS coordinates as a
 * status-coloured marker — a lightweight heatmap-style overview for admins.
 */
export default function ViolationsMap({ violations = [] }) {
    const points = violations.filter(
        (v) => typeof v.latitude === 'number' && typeof v.longitude === 'number'
    );

    if (points.length === 0) {
        return (
            <div className="h-80 rounded-lg border flex items-center justify-center text-sm text-muted-foreground">
                No geotagged violations to map for the current filter.
            </div>
        );
    }

    const center = [points[0].latitude, points[0].longitude];

    return (
        <div className="h-[28rem] rounded-lg overflow-hidden border">
            <MapContainer center={center} zoom={11} scrollWheelZoom={false} style={{ height: '100%', width: '100%' }}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                />
                {points.map((v) => (
                    <CircleMarker
                        key={v.id}
                        center={[v.latitude, v.longitude]}
                        radius={8}
                        pathOptions={{
                            color: STATUS_COLOR[v.status] || '#888',
                            fillColor: STATUS_COLOR[v.status] || '#888',
                            fillOpacity: 0.5,
                            weight: 2,
                        }}
                    >
                        <Tooltip>
                            <div className="space-y-1">
                                <p className="font-mono font-semibold">{v.vehicle_number}</p>
                                <ViolationTypeBadge type={v.violation_type} />
                            </div>
                        </Tooltip>
                    </CircleMarker>
                ))}
            </MapContainer>
        </div>
    );
}
